<!-- 隐私协议 -->
<template>
  <div class="secret">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <div class="secretCon width">
      <h3>云图工业互联网平台隐私政策声明</h3>
      <h4>提示条款</h4>
      <p>
        尊敬的用户、服务商及云图工业互联网平台的合作伙伴，我们深知信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的信息安全。由此云图工业互联网平台（简称“云图”）制定《云图工业互联网平台隐私政策声明》（以下或简称“本政策”）并提醒您： 在使用云图工业互联网平台网站的各项服务前，请您务必仔细阅读并理解本《隐私政策》，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用云图平台服务，将被视为对本声明和政策内容的接受和认可。
        如对本声明和政策内容有任何疑问、意见或建议，您可通过云图平台的客服、邮箱或客服电话与我们联系。
      </p>
      <h4>定义</h4>
      <p>云图： 指云图工业互联网平台网站（域名为：云图.com）以及所有下属页面。 在使用云图工业互联网平台网站的各项服务前，请您务必仔细阅读并理解本《隐私政策》，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用云图平台服务，将被视为对本声明和政策内容的接受和认可。</p>
      <p>云图的关联公司： 指海尔集团、卡奥斯物联生态有限公司及子公司。</p>
      <p>用户信息： 用户信息是指您注册云图账户，使用云图的服务以及云图为了向您提供服务，您提交的或者云图收集的用户信息，如姓名、联系方式等，具体详见隐私权政策第二条所述的信息。</p>
      <h4>声明</h4>
      <h4>一、权利归属</h4>
      <p>（1） 云图 Logo、“云图”等文字、图形及其组合，以及云图网站的其他标识未经云图书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。</p>
      <p>（2）云图网站所有的产品、服务、技术的知识产权均归属于云图或归其权利人所有。</p>
      <p>（3）除非云图另行声明，云图拥有在网站内发布文档等信息的所有权利。未经云图许可，任何人不得擅自使用。</p>
      <h4>二、责任限制</h4>
      <p>（1）云图用户/服务商在云图网站自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、 联系人及联络信息，相关图片、资讯等，该等信息均由用户/服务商自行提供，须对其提供的任何信息依法承担全部责任。</p>
      <p>（2）云图上用户/服务商上传的信息（包括不限于工业APP、产品详情、资讯文章等）量大且复杂，并不意味云图赞同其观点或证实其内容的真实性。</p>
      <p>（3）云图在此提示，您在使用云图服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用云图的服务从事他人侵犯名誉、隐私、知识产权和其他合法权益的活动，云图不对您使用云图服务的用途和目的承担任何责任。</p>
      <h4>三、知识产权保护</h4>
      <p>我们尊重知识产权，反对并打击侵犯知识产权的行为。任何组织或个人认为云图内容可能侵犯其合法权益的，可以通过客服、邮箱、电话等提出通知，我们将在收到知识产权权利人合格通知后依法尽快处理。</p>
      <h4>四、如何联系我们</h4>
      <p>
        您对本政策内容有任何疑问或建议，或者您对云图关于本隐私政策的实践以及操作上有任何疑问，您可通过云图的客服（4001357277）、邮箱（support@云图.com）与我们联系。
        隐私权政策
      </p>
      <p>云图尊重并保护用户/服务商信息，并且以高度谨慎和认真的态度对待这些信息。在您使用了云图提供的服务时，我们将按照本政策收集、处理及披露您的信息。我们希望通过本政策向您清晰地介绍我们对您信息的处理方式，因此我们建议您完整地阅读本政策，以帮助您了解维护自己隐私权的方式。</p>
      <p>如果您有任何疑问、意见或建议，请通过云图提供的各种联系方式与我们联系。</p>
      <p>本政策将帮助您了解以下内容：</p>
      <p>一、本协议的适用范围</p>
      <p>（1）本隐私权政策适用于云图所有服务以及通过云图向您提供的技术服务。</p>
      <p>（2）本政策不适用于其他第三方向您提供的服务。例如，云图上的服务商依托云图向您提供服务时，您向服务商提供的信息不适用本隐私权政策。</p>
      <p>（3）作为云图的服务商，若您利用云图的技术为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定隐私权政策。</p>
      <p>二、云图如何收集和使用您的信息</p>
      <p>（1）当您在云图网站创建账户时，您提交的手机号码或邮箱用于您注册、登录、绑定账户、密码找回时接受验证码，并且作为您与云图指定的联系方式之一，用来接受相关业务通知。</p>
      <p>（2）在您注册完成云图账户后，您可以在用户后台中继续填写您的相关信息，如例如地址、邮政编码、姓名、护照或其他身份信息、银行账户信息、电子邮箱、您的公司名称、行业、职位、发票信息、税务信息。您完善后的信息会帮助我们更了解您对于云图服务需求，以便云图有针对性的向您提供服务。您若不提供这些信息，将不会影响您对某一具体服务的使用。</p>
      <p>（3）如果您仅需使用云图的浏览、搜索等基本服务，您不需要注册及提供上述信息。</p>
      <p>三、向您提供服务</p>

      <p>（1）根据中华人民共和国法律，在您使用具体的服务时，如有要求，您应遵守云图服务的相关流程及规范提供您的真实身份信息。</p>
      <p>（2）如果您作为服务商，应当保证您企业的相关信息（包括不限于公司名称、企业性质、营业执照注册号、银行账户信息等）真实可靠。</p>
      <p>（3）当您使用云图提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、访问日期和时间及您访问的网页记录等。</p>
      <p>（4）基于您使用云图服务而产生的咨询记录和针对用户/服务商故障的排障过程（如通信或通话记录），云图将通过记录、分析这些信息以便更及时响应您的帮助请求，改进云图服务。</p>
      <p>（5）我们在向您提供业务功能或具体服务时，我们会按照本政策以及相应的产品服务协议的约定收集、使用、存储、对外提供及保护您的信息；超出本政策以及相应的产品服务协议约定收集您的用户信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意后，收集相应服务所必要的您的信息。</p>
      <p>四、我们何时会使用您的信息</p>
      <p>我们出于如下目的，使用您提交以及我们收集的信息：</p>
      <p>（1）为了向您提供服务，我们会向您发送信息、通知或其他形式与您进行业务沟通。</p>
      <p>（2）为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们可能将来自云图某项服务的用户信息与来自其他项服务的信息结合起来，做出特征模型并进行用户画像，向您展示、推送信息，包括但不限于关于云图的新闻以及市场活动及优惠促销信息、云图合作第三方的推广信息，或其他您可能感兴趣的内容。</p>
      <p>（3）我们可能以用户/服务商信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息。</p>
      <p>（4） 云图可能使用您的信息、有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易是否存在风险，并依法采取必要的记录、分析、处置措施。</p>
      <p>（5）在超出具有直接或合理关联的范围使用用户信息前，我们会再次向您告知并征得您的明确同意。</p>
      <h4>五、我们如何共享、公开披露您的用户信息</h4>
      <p>（1）共享</p>
      <p>我们不会与其他组织和个人共享您的用户信息，但以下情况除外：</p>
      <p>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息。此外，我们可能会根据法律法规规定、诉讼或按行政司法机关依法提出的要求，对外共享您的用户信息；</p>
      <p>2、与授权合作伙伴共享：我们可能委托受信赖的合作伙伴来提供服务，因此我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的合作伙伴无权将共享的用户信息用于任何其他用途。</p>
      <p>目前，我们的授权合作伙伴包括如下类型：工业互联网类平台、入驻云图并提供服务的服务商和其他合作伙伴。我们将信息发送给支持我们业务的合作伙伴，这些支持包括提供技术服务、咨询、行业及领域的专业服务等。</p>
      <p>（2）公开披露</p>
      <p>我们仅会在以下情况下，公开披露您的用户信息：</p>
      <p>（1）获得您明确同意或基于您的主动选择，我们可能会公开披露您的信息；</p>
      <p>（2）或为保护云图及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或云图相关协议、条款披露关于您的信息。例如，若您作为云图服务商提供虚假服务，我们可能会公开披露您的店铺主体信息与处罚情况。</p>
      <p>（3）共享、公开披露用户信息时事先征得授权同意的例外</p>
      <p>以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：</p>
      <p>1、与国家安全、国防安全、公共安全、公共卫生、重大公共利益有关的；</p>
      <p>2、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p>3、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>4、您自行向社会公众公开的个人信息；</p>
      <p>5、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <h4>六、服务商业务数据和公开信息</h4>
      <p>不同于用户信息，对于服务商业务数据和公开信息，云图将按如下方式处理</p>
      <p>（1） 业务数据</p>
      <p>1、通过云图提供服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的业务数据，您完全拥有您的业务数据。云图作为服务提供商，我们只会严格按照您的指示处理您的业务数据，除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。</p>
      <p>2、您应对您的业务数据来源及内容负责，请您谨慎判断数据来源及内容的合法性。因您的业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。</p>
      <p>3、根据您与云图协商一致，云图在您选定的数据中心存储业务数据，云图恪守安全承诺，根据适用的法律保护存储在云图的数据。</p>
      <p>（2）公开信息</p>
      <p>1、公开信息是指您公开分享的任何信息，任何人都可以在使用和未使用云图网站服务期间查看或访问这些信息。</p>
      <p>2、作为服务商，您应当根据适用的法律法规和云图规则的要求，公开分享企业或者自然人经营者的相关信息。</p>
      <p>3、在使用云图进行交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址。请您妥善保护自己的信息，仅在必要的情形下向他人提供。您也可以通过我们的服务体系与客户建立联系和相互分享。如您发现自己的信息泄漏，尤其是账户或密码发生泄露，请您立即联络云图，以便云图采取相应措施。</p>
      <h4>七、我们如何使用Cookie和同类技术</h4>
      <p>（1）为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。云图只能读取云图提供的cookies。</p>
      <p>（2）借助于 Cookie，能够存储您的偏好或购买清单中的商品等数据。当下一次您再次访问的时候，我们将显示您需要的信息；或由云图通过cookies文件来辨识您的来源网站，以便我们能追踪云图的广告效果。</p>
      <p>（3）您可根据自己的偏好管理Cookie，您也可以清除计算机上保存的所有 Cookie。大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。</p>
      <p>（4）除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</p>
      <h4>八、云图保护和保存信息</h4>
      <p>（1）云图非常重视信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息。防止信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会部署访问控制机制，尽力确保只有授权人员才可访问用户信息。</p>
      <p>（2） 请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
      <p>（3）在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。</p>
      <h4>九、注销账户</h4>
      <p>（1）您可以通过提交请求来申请注销您的云图平台账户。我们不会设置不合理的条件来阻止您注销账户，但如果注销账户将会影响您或他人的合法权益，例如您有待接收的货物、已付费而未到期的服务等，则我们会结合您对云图服务的使用情况来判断并告知是否支持您的注销请求。</p>
      <p>（2） 注销账户会影响您正常使用所有相关应用和服务。我们在此善意地提醒您，您注销账户的行为会给您后续使用云图平台服务带来诸多不便，且注销云图平台账户后，我们将停止为您提供服务，您的个人信息会保持不可被检索、访问的状态，或被匿名化处理，法律法规另有规定的除外。如您通过第三方账号快捷登录的，您需要联系该第三方处理注销账号事宜。</p>
      <p>（3）如果您已经深思熟虑，确定放弃账户，并符合所有注销条件，您可以通过列明的联系方式联系我们进行相关操作。云图平台账户一旦被注销将不可恢复，请您在操作之前自行备份云图平台账户相关的所有信息和数据。因您申请注销账户对您造成的不利影响，云图平台不承担任何责任。</p>
      <h4>十、未成年人用户信息</h4>
      <p>我们主要面向成人提供产品和服务。如您为未成年人，我们要求您请您的监护人仔细阅读本隐私政策，并在征得您监护人同意的前提下使用我们的服务或向我们提供信息。</p>
      <h4>十一、隐私政策的更新</h4>
      <p>我们的隐私政策可能修订，我们会在云图显著位置上发布对隐私权政策所做的任何修订，对于重大修订，我们还会提供更为直接、显著的通知（例如通过网站公告、弹窗提示等说明隐私权政策的具体变更内容）。</p>
      <p>更新于：2021年3月2日</p>
      <p>© 江苏称意智能科技有限公司 版权所有，保留一切权利。</p>
      <p>最终解释权 本协议制定的各项规则最终解释权归云图所有。</p>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '',
        bgImg: require('../assets/images/u570.png'),
        content: '',
        bl: false,
      },
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="less">
h3 {
  font-size: 18px;
  text-align: center;
}
h4 {
  font-size: 16px;
}
p {
  line-height: 18px;
}
</style>
